import { render, staticRenderFns } from "./AccepterPasswordReconfigRequest.vue?vue&type=template&id=18c53740&"
import script from "./AccepterPasswordReconfigRequest.vue?vue&type=script&lang=ts&"
export * from "./AccepterPasswordReconfigRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports